
import React, { useState } from 'react';
import '../styles/GeneralStyles.css';
import iconRadio1 from '../assets/ring-vector-1.svg'
import iconArrowLeft from '../assets/arrow-left.svg'
import iconArrowRight from '../assets/arrow-right.svg'
import imgColorD from '../assets/color/tressor_color_D.webp'
import imgColorE from '../assets/color/tressor_color_E.webp'
import imgColorF from '../assets/color/tressor_color_F.webp'
import imgColorG from '../assets/color/tressor_color_G.webp'
import imgColorH from '../assets/color/tressor_color_H.webp'
import portadaColor from '../assets/portadas/Portada-04-Color.webp'

const Step3 = ({ nextStep, prevStep, handleInputChange, formData }) => {
  const [selectedOption, setSelectedOption] = useState(formData?.ringColor || null);

  const options = [
    {
      id: 1,
      icon: iconRadio1, 
      text: "D",
      value1: 3440,
      value2: 8600,
      value3: 19676,
      value4: 32250,
      title: "Color D",
      description: "Grado más alto, absolutamente «incoloro»",
      image: imgColorD,
    },
    {
      id: 2,
      icon: iconRadio1,
      text: "E", 
      value1: 2150,
      value2: 6450,
      value3: 7095,
      value4: 19350,
      title: "Color E",
      description: "Un grado «incoloro»",
      image: imgColorE
    },
    {
      id: 3,
      icon: iconRadio1,
      text: "F",
      value1: 1075,
      value2: 4300,
      value3: 4730,
      value4: 10750,
      title: "Color F",
      description: "Color débil detectable por un gemólogo experto.",
      image: imgColorF
    },
    {
      id: 4,
      icon: iconRadio1,
      text: "G",
      value1: 645,
      value2: 2150,
      value3: 2365,
      value4: 7525,
      title: "Color G",
      description: "El grado «casi incoloro» más alto. Excelente relación calidad-precio",
      image: imgColorG
    },
    {
      id: 5,
      icon: iconRadio1,
      text: "H",
      value1: 0,
      value2: 0,
      value3: 0,
      value4: 0,
      title: "Color H",
      description: "Grado «casi incoloro» el color sólo es perceptible cuando se compara con grados de color muy superiores. Valor excelente.",
      image: imgColorH
    }
  ];

  const handleOptionSelect = (option) => {
    const selectedCaratId = formData?.carats?.selectedId;
    const valueKey = `value${selectedCaratId}`;
    const finalValue = selectedCaratId ? option[valueKey] : option.value1;

    setSelectedOption(option);
    handleInputChange('ringColor', {
      ...option,
      value: finalValue
    });
  };

  return (
    <div className='container-large'>
      <div className='wrapp-principal-2-columns'>
        <div className="options-column">
          <div className='text-n-options'>
          <h2 className='heading-style-h3 text-align-center'>Escoge el Color que más te inspire para el diamante</h2>
          <p className='text-size-medium text-color-grey'>En Tressor recomendamos  diamantes con color de la D a la H, pues al ser una característica sumamente importante y visible, influye en cómo se refleja la luz en el diamante</p>
          <div className='container-radio-options'>
          <div className='wrapp-radio-options'>
          <div className="radio-options">
            {options.map((option) => (
              <label key={option.id} className="radio-label">
                <input
                  type="radio"
                  name="ringStyle"
                  checked={selectedOption?.id === option.id}
                  onChange={() => handleOptionSelect(option)}
                />
                <img src={option.icon} className="radio-icon" alt="ring icon" />
                <span className="radio-text">{option.text}</span>
              </label>
            ))}
          </div>
          </div>
          </div>
          </div>
          
          <div className="wrapp-btns">
        <button className="button-prev" onClick={prevStep}>
          <img src={iconArrowLeft} alt="arrow left" />
          Volver
        </button>
        <button 
          className="button" 
          onClick={nextStep}
          disabled={!selectedOption}
        >
          Siguiente
          <img src={iconArrowRight} alt="arrow right" />
        </button>
      </div>
        </div>
        
        <div className="preview-column">
          
          {selectedOption ? (
            <>
            <div className='imgOptionSelected'>
            <img 
                src={selectedOption.image} 
                alt={selectedOption.text}
                className="ring-preview-image"
              />

            </div>
            <div className='textOptionSelected'>
            <h3 className="text-align-left">{selectedOption.title}</h3>
              <p className="text-style-medium text-align-left">
                {selectedOption.description}
              </p>
            </div>
              
              
            </>
          ) : (
            <div className="no-selection-message">
              
              <img src={portadaColor} className='imgPreviewNoText' alt="Portada Color"/>
              <div className='wrappNoSelectText'>
                <p className='heading-style-h4 text-weight-bold text-color-white'>Color</p>
                <p className='text-size-large text-color-white'>Por favor selecciona color</p>
              </div>
              

            </div>
          )}
        </div>
      </div>

      
    </div>
  );
};

export default Step3;





